import React from "react";

export default function Cookies() {
  return (
    <div data-testid="cookies-page" className="mx-auto max-w-3xl px-5 lg:px-10 py-16">
      <h1 className="font-display-black text-5xl sm:text-6xl mb-6">Cookies</h1>
      <p className="text-lg leading-relaxed">
        Bon Sang utilise uniquement des cookies fonctionnels et de mesure d&apos;audience
        anonymisée. Aucun cookie publicitaire tiers. Tu peux refuser à tout moment
        via le bandeau présent en bas de page.
      </p>
      <ul className="list-disc pl-5 mt-6 space-y-2">
        <li>Mesure d&apos;audience anonyme (durée, pages vues)</li>
        <li>Préférences d&apos;affichage</li>
        <li>Aucun partage commercial</li>
      </ul>
    </div>
  );
}
